import {equals, find, flow, get, isEmpty, makeGet, pipe} from '@yandex-delivery/utils'

import type {ClientLaunchInfo, ErrorWithMessage, LaunchResponse} from '../types'

type Companies = ClientLaunchInfo[]
type Company = ClientLaunchInfo

const launchGetter = makeGet<LaunchResponse>()

export const getCompanies: (res: LaunchResponse) => Companies = launchGetter('companies')
export const getYandexLogin = launchGetter('passport_account.yandex_login')
export const getYandexUID = launchGetter('passport_account.yandex_uid')
export const getYandexPhone = launchGetter('passport_account.details.phones[0].phone')
export const getIsStaff = launchGetter('passport_account.details.is_staff')
export const getDisableReason: (res: LaunchResponse) => ErrorWithMessage | undefined = launchGetter(
  'allowed_new_registrations.cargo_phoenix.disable_reason',
)
export const isYandexLoginEmpty: (res: LaunchResponse) => boolean = //
  flow(launchGetter('passport_account.yandex_login'), isEmpty)
export const isPrimaryPhoneEmpty: (res: LaunchResponse) => boolean = //
  flow(launchGetter('passport_account.details.phones[0].phone'), isEmpty)
export const isCompaniesEmpty: (res: LaunchResponse) => boolean = //
  flow(getCompanies, isEmpty)
export const isUnAuthenticated: (launch: LaunchResponse) => boolean = //
  flow(
    launchGetter('allowed_new_registrations.cargo_phoenix.disable_reason.code'), //
    equals('unauthenticated'),
  )
export const findCompanyByID = (launch: LaunchResponse, clientID: string): Company | undefined => {
  const findCompany: (companies: Companies) => Company | undefined = //
    find(flow(get('id'), equals(clientID)))

  return pipe(
    launch, //
    getCompanies,
    findCompany,
  )
}
export const getClientCountry: (launch: LaunchResponse, clientID: string) => string | undefined = flow(
  findCompanyByID,
  get('country'),
)
